import {
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  ViewChild,
} from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgxPaginationModule } from "ngx-pagination";
import * as FileSaver from "file-saver";
import { BaseComponent } from "../../base/base.component";
import { FunctionService } from "../../services/function.service";
import { ActivatedRoute, Router } from "@angular/router";
import {
  IDropdownSettings,
  NgMultiSelectDropDownModule,
} from "ng-multiselect-dropdown";
import { catchError, forkJoin, Observable, of } from "rxjs";
import {
  ColumnCustomizeComponent,
  TableColumn,
} from "../column-customize/column-customize.component";
import { OrderByPipe } from "../../base/order-by.pipe";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ErrorHelperService } from "../../services/error-helper.service";
import { NotificationService } from "../../services/notification.service";
import { Carrier } from "../../interfaces/anagraphic.interfaces";
import { ShipmentManagementService } from "../../services/shipment-management.service";
import { OverviewHarmonizerService } from "../../services/overview-harmonizer.service";
import SignaturePad from "signature_pad";
import { OnDestroy } from "@angular/core";
import { Dealer } from "../trackingDetails/trackingDetails.component";
import { TourRouting } from "../../interfaces/TourRouting.interfaces";

interface Region {
  regionCode: string;
  regionName?: string;
}

export interface ViewParcels {
  parcelWaybillCode: string;
  parcelCode: string;
  parcelDate: string;
  parcelDeliveryDate: string;
  parcelEstimatedDeliveryDate: string;
  parcelDealerCode: string;
  dealerName: string;
  dealerOperatingAddressStreet: string;
  dealerOperatingAddressCity: string;
  dealerLatitude: number;
  dealerLongitude: number;
  parcelDescription: string;
  parcelDeliveryType: string;
  parcelWeight: number;
  parcelVolume: number;
  parcelBarcode: string;
  parcelTrackingNumber: string;
  parcelLatitude: number;
  parcelLongitude: number;
  parcelNotifiedStatus: string;
  parcelDeliveryStatus: string;
  parcelModifyManual: string;
  distanceInMeters: number;
  coordinatesInRange: string;
  parcelWaybillCarrierCode: string;
  parcelWaybillCarrierName: string;
  parcelWaybillOriginLocation: string;
  parcelWaybillLastMileOrigin: string;
  parcelWaybillDeliveryMethod: string;
  parcelRegionCode: string;
  parcelRegionName: string;
  showTrackings?: boolean;
  parcelWaybillDeliveryType: string;
  parcelDeliveryReason: string;
  parcelOnTime: string;
  parcelOriginalDeliveryDate: string;
  parcelOriginalLatitude: number;
  parcelOriginalLongitude: number;
  parcelDeliveryDateIsForced: string;
  parcelDeliveryDateIsUpdated: string;
  parcelDeliveryCoordinatesIsForced: string;
  parcelDeliveryCoordinatesIsUpdated: string;
  parcelWaybillLastKnownLocation: string;
  parcelBrandCode: string;
  parcelClientCode: string;
  brandName: string;
  clientName: string;
  minutesDelay: number | null;
  waybillScheduleType: string;
  distanceOriginalInMeters: number;
  parcelJustificationId: number;
  parcelJustificationComment: string;
  parcelWaybillLoadingBay: string;
  parcelWaybillStatus: string;
  isRoutingPresent: string;
  parcelCurrentWarehouse: string;
  parcelWaybillMaximumRange: number;
  parcelWarehouseExternalCode: string;
  parcelDetailStatus: string;
  tourRoutingExternal: string;
  parcelOriginalWaybillCode: string;
  parcelHasMisrouting: string;
  waybillDdtAttachments: string;
  isRestrictedClient: string;
  waybillShipmentCode: string;
  clientRequestSignature?: string;
  parcelType?: string;
  parcelPalletType?: string;
  parcelPalletDescription?: string;
  isBigOrder?: boolean;
  parcelDeliveryChangeCutoffDate?: string;
  parcelDeliveryChangeCutoffCountdown?: string;
  parcelDeliveryChangeCutoffExpired?: boolean;
  parcelDeliveryChangeCutoffWarning?: boolean;
}

interface Warehouse {
  warehouseCode: string;
  warehouseName?: string;
  warehouseShortName?: string;
  warehouseType?: string;
}

interface Justification {
  justificationId: number;
  justificationName?: string;
}

interface Client {
  clientCode: string;
  clientName?: string;
}

interface Brand {
  brandCode: string;
  brandName?: string;
}

interface ClientsBrands {
  clientCode: string;
  clientName?: string;
  brands: Brand[];
}

export enum ParcelDetailStatus {
  PREPARED = "Preparata",
  IN_TRIP_TO_TP = "In viaggio verso TP",
  IN_TRIP = "In viaggio verso dealer",
  CLOSED = "Chiuso",
  SUSPENDED = "Sospeso",
}

@Component({
  selector: "app-overview-harmonizer",
  standalone: true,
  templateUrl: "./overview-harmonizer.component.html",
  styleUrls: ["./overview-harmonizer.component.css"],
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    NgxPaginationModule,
    NgMultiSelectDropDownModule,
    ColumnCustomizeComponent,
    OrderByPipe,
    MatTooltipModule,
  ],
})
export class OverviewHarmonizerComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @ViewChild("signatureCanvas") signatureCanvas?: ElementRef<HTMLCanvasElement>;

  showImportExcelModal = false;
  // Export in corso: lo spinner compare solo sul pulsante premuto, l'altro resta disabilitato
  exportingType: "standard" | "original" | null = null;

  get isExporting(): boolean {
    return this.exportingType !== null;
  }
  selectedExcelFile!: File;

  private countdownInterval: any = null;

  private signaturePad!: SignaturePad;

  signaturePreview: string | null = null;
  signatureError: string | null = null;
  private signatureInitialized = false;
  isReplacingSignature = false;

  parcelSignature: string | null = null;

  ParcelDetailStatus = ParcelDetailStatus;

  numberParcelsOfWaybillNotOnTime: number = 0;
  numberParcelsOfWaybill: number = 0;
  currentPage: number = 1;
  itemsPerPage: number = 25;

  parcels: ViewParcels[] = [];
  filteredParcels: ViewParcels[] = [];

  successDeliveryPropagation = false;
  errorDeliveryPropagation: string | null = null;

  errorDeliveryNull: boolean = false;

  searchDealerCode: string = "";
  searchDDTCodes: string = "";
  searchParcelCode: string = "";
  searchParcelWaybillCode: string = "";
  parcelDateStart: string = "";
  parcelDateEnd: string = "";

  showUndefinedParcels: boolean = false;
  showBigOrders: boolean = false;

  parcelEstimatedDeliveryDateStart: string = "";
  parcelEstimatedDeliveryDateEnd: string = "";

  scheduleType: string = "";
  scheduleIsNight: string = "";

  dateError: string = "";
  isLoading: boolean = false;

  loadingComParcels = false;
  errorLoading = false;

  totalRecords: number = 0;
  // Per il riquadro "Totale colli": "–" finché non c'è una ricerca, spinner mentre si caricano i colli
  hasSearched = false;
  isLoadingParcels = false;

  isCoordinatesCorrectSelectedParcel: boolean = false;
  showButtonCreateCoordinates: boolean = false;

  notificationStatus: string = ""; // "not_notified" | "notified"
  deliveryStatus: string = ""; // "delivered" | "not_delivered"
  inRangeStatus: string = "";
  modifyStatus: string = ""; // modified | not_modified
  withProblemsStatus: string = "";
  onTimeStatus: string = "";
  justificationStatus: string = "";
  misroutingStatus: string = "";

  showFilters: boolean = true;

  selectedParcel: ViewParcels | null = null;
  showModal: boolean = false;

  showModalDetailModifies: boolean = false;

  showNotification = false;
  notificationMessage = "";

  showRollbackModal = false;
  rollbackChoice: "parcel" | "waybill" | null = null;

  editChoice: "parcel" | "waybill" | null = null;

  editForm: any = {
    parcelDate: "",
    parcelDeliveryDate: "",
    parcelDescription: "",
    parcelWeight: 0,
    parcelVolume: 0,
    parcelLatitude: null as number | null,
    parcelLongitude: null as number | null,
  };

  restrictedMinutes: number | null = null;

  parcelDetailStatusOptions = [
    { value: "PREPARED", label: ParcelDetailStatus.PREPARED },
    { value: "IN_TRIP_TO_TP", label: ParcelDetailStatus.IN_TRIP_TO_TP },
    { value: "IN_TRIP", label: ParcelDetailStatus.IN_TRIP },
    { value: "CLOSED", label: ParcelDetailStatus.CLOSED },
    { value: "SUSPENDED", label: ParcelDetailStatus.SUSPENDED },
  ];

  private originalEdit: {
    parcelDeliveryDate: string | null;
    parcelLatitude: number | null;
    parcelLongitude: number | null;
  } = {
    parcelDeliveryDate: null,
    parcelLatitude: null,
    parcelLongitude: null,
  };

  get isDateChanged(): boolean {
    const current = this.editForm?.parcelDeliveryDate ?? null;
    const initial = this.originalEdit?.parcelDeliveryDate ?? null;
    return current !== initial;
  }

  get isParcelChanged(): boolean {
    const dateChanged = this.isDateChanged;
    const latChanged =
      (this.editForm?.parcelLatitude ?? null) !==
      (this.originalEdit?.parcelLatitude ?? null);
    const lonChanged =
      (this.editForm?.parcelLongitude ?? null) !==
      (this.originalEdit?.parcelLongitude ?? null);
    const signatureChanged = this.isSignatureChanged;

    return !!(dateChanged || latChanged || lonChanged || signatureChanged);
  }

  filteredWarehouses: Warehouse[] = [];
  filteredWarehousesFrom: Warehouse[] = [];
  warehouseCode: string = "";
  warehouseFromCode: string = "";

  filteredBrands: Brand[] = [];

  selectedDealerCode: string = "";
  filteredDealers: Dealer[] = [];

  selectedCarrierCode: string = "";
  filteredCarriers: Carrier[] = [];

  selectedRegionCode: string = "";
  filteredRegions: Region[] = [];

  selectedDeliveryType: string = "";
  filteredTours: TourRouting[] = [];

  filterOnlyWithCoordsAndNoDeliveryDate: string = "";

  sortState = {
    active: "PARCEL_DELIVERY_CHANGE_CUTOFF_DATE",
    direction: "ASC",
  };

  selectedBrands: Brand[] = [];
  filteredClients: Client[] = [];
  selectedClients: Client[] = [];
  clientsBrands: ClientsBrands[] = [];

  dropdownSettingsBrand: IDropdownSettings = {};
  dropdownSettingsClient: IDropdownSettings = {};

  selectedDeliveryMethod: string = "";

  showJustificationModal: boolean = false;

  editFormJustification: any = {
    parcelJustificationId: "",
    parcelJustificationComment: "",
  };

  selectedDealers: any[] = [];
  selectedCarriers: any[] = [];
  selectedWarehousesFrom: any[] = [];
  selectedWarehouses: any[] = [];
  selectedRegions: any[] = [];
  selectedTours: any[] = [];
  selectedParcelDetailStatuses: any[] = [];

  dropdownSettingsStatus: any;
  dropdownSettingsDealer: any;
  dropdownSettingsCarrier: any;
  dropdownSettingsWarehouseFrom: any;
  dropdownSettingsWarehouse: any;
  dropdownSettingsRegion: any;
  dropdownSettingsTour: any;

  columns: TableColumn[] = [
    {
      field: "actions",
      label: "Azioni",
      visible: true,
      order: 1,
      updatableOnly: true,
    },
    {
      field: "parcelWaybillStatus",
      label: "Stato Bolla",
      visible: true,
      order: 2,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "parcelDetailStatus",
      label: "Stato",
      visible: true,
      order: 3,
      sortable: true,
    },
    {
      field: "clientName",
      label: "Cliente",
      visible: true,
      order: 6,
      sortable: true,
    },
    {
      field: "brandName",
      label: "Marchio",
      visible: true,
      order: 7,
      sortable: true,
    },
    {
      field: "parcelCode",
      label: "Codice Collo",
      visible: true,
      order: 8,
      sortable: true,
    },
    {
      field: "parcelWaybillCode",
      label: "Codice Nuova Bolla",
      visible: true,
      order: 9,
      sortable: true,
      specialOnly: true,
    },
    {
      field: "parcelOriginalWaybillCode",
      label: "Codice Bolla",
      visible: true,
      order: 10,
      sortable: true,
    },
    {
      field: "waybillDdtAttachments",
      label: "Codici DDT",
      visible: true,
      order: 11,
      sortable: true,
    },
    // { field: "parcelWaybillCodeFull", label: "Codice Spedizione", visible: true, order: 7, sortable: true },
    {
      field: "parcelDate",
      label: "Data Affido",
      visible: true,
      order: 12,
      sortable: true,
    },
    {
      field: "parcelWaybillOriginLocation",
      label: "Magazzino partenza",
      visible: true,
      order: 13,
      sortable: true,
    },
    {
      field: "parcelWaybillCarrierName",
      label: "Vettore",
      visible: true,
      order: 14,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "parcelDealerCode",
      label: "Codice Destinatario",
      visible: true,
      order: 15,
      sortable: true,
    },
    {
      field: "dealerName",
      label: "Destinatario",
      visible: true,
      order: 20,
      sortable: true,
    },
    {
      field: "dealerOperatingAddressStreet",
      label: "Indirizzo destinatario",
      visible: true,
      order: 23,
      sortable: true,
    },
    {
      field: "dealerOperatingAddressCity",
      label: "Città destinatario",
      visible: true,
      order: 24,
    },
    {
      field: "parcelRegionName",
      label: "Regione",
      visible: true,
      order: 25,
      sortable: true,
    },
    {
      field: "parcelDeliveryDate",
      label: "Data Consegna",
      visible: true,
      order: 4,
      sortable: true,
    },
    {
      field: "parcelEstimatedDeliveryDate",
      label: "Stima Consegna",
      visible: true,
      order: 5,
      sortable: true,
    },
    {
      field: "parcelDeliveryChangeCutoffDate",
      label: "Cutoff Modifica",
      visible: true,
      order: 30,
      specialOnly: true,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "parcelDeliveryChangeCutoffCountdown",
      label: "Tempo residuo cutoff",
      visible: true,
      order: 31,
      specialOnly: true,
      updatableOnly: true,
      sortable: false,
    },
    {
      field: "parcelOnTime",
      label: "In Orario",
      visible: true,
      order: 32,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "minutesDelay",
      label: "Ritardo (min)",
      visible: true,
      order: 36,
      sortable: true,
    },
    {
      field: "parcelWaybillDeliveryMethod",
      label: "Tipologia Consegna",
      visible: true,
      order: 37,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "tourRoutingExternal",
      label: "Tour",
      visible: true,
      order: 39,
      sortable: true,
    },
    {
      field: "parcelDeliveryReason",
      label: "Causale di consegna",
      visible: true,
      order: 42,
      sortable: true,
    },
    { field: "parcelLatitude", label: "Lat", visible: true, order: 43 },
    { field: "parcelLongitude", label: "Lng", visible: true, order: 44 },
    {
      field: "distanceInMeters",
      label: "Distanza (m)",
      visible: true,
      order: 45,
      sortable: true,
    },
    {
      field: "parcelModifyManual",
      label: "Data Modifica",
      visible: true,
      order: 48,
      specialOnly: true,
      sortable: true,
    },
    // { field: "pod", label: "POD", visible: true, order: 49 },
  ];

  constructor(
    public http: HttpClient,
    functionService: FunctionService,
    router: Router,
    private notificationService: NotificationService,
    private errorHelperService: ErrorHelperService,
    private route: ActivatedRoute,
    private shipmentManagementService: ShipmentManagementService,
    private overviewHarmonizerService: OverviewHarmonizerService,
  ) {
    super(functionService, router); // Passa i servizi al costruttore padre
  }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const qpDeliveryStatus = params.get("deliveryStatus");
    const qpOnTimeStatus = params.get("onTimeStatus");
    const qpRegionCode = params.get("regionCode");
    const qpParcelDateStart = params.get("parcelDateStart");
    const qpParcelDateEnd = params.get("parcelDateEnd");
    const qpParcelEstimetedDateStart = params.get("parcelEstimetedDateStart");
    const qpParcelEstimetedDateEnd = params.get("parcelEstimetedDateEnd");
    const qpParcelWithProblemsStatus = params.get("withProblemsStatus");
    const qpInRangeStatus = params.get("inRangeStatus");

    if (qpDeliveryStatus) {
      this.deliveryStatus = qpDeliveryStatus;
    }

    if (qpOnTimeStatus) {
      this.onTimeStatus = qpOnTimeStatus;
    }

    if (qpParcelWithProblemsStatus) {
      this.withProblemsStatus = qpParcelWithProblemsStatus;
    }

    if (qpRegionCode) {
      this.selectedRegionCode = qpRegionCode;
    }

    if (qpParcelDateStart) {
      this.parcelDateStart = qpParcelDateStart;
    }

    if (qpParcelDateEnd) {
      this.parcelDateEnd = qpParcelDateEnd;
    }

    if (qpParcelEstimetedDateStart) {
      this.parcelEstimatedDeliveryDateStart = qpParcelEstimetedDateStart;
    }

    if (qpParcelEstimetedDateEnd) {
      this.parcelEstimatedDeliveryDateEnd = qpParcelEstimetedDateEnd;
    }

    if (qpInRangeStatus) {
      this.inRangeStatus = qpInRangeStatus;
    }

    const saved = localStorage.getItem("parcelTableConfig");
    if (saved) {
      this.columns = JSON.parse(saved);
    }
    this.columns = this.columns.filter((col) => this.isColumnAllowed(col));

    this.columns.sort((a, b) => a.order - b.order);

    const savedPage = localStorage.getItem("currentParcelPage");
    this.currentPage = savedPage ? +savedPage : 1;

    // Recupera anche itemsPerPage dal localStorage
    const savedItemsPerPage = localStorage.getItem("itemsPerPage");
    this.itemsPerPage = savedItemsPerPage ? +savedItemsPerPage : 25;

    this.parcels = [];
    this.filteredParcels = [];

    //this.calcolaDataDefaultFiltri();

    const stored = localStorage.getItem("userFunctions");
    if (stored) {
      const parsed = JSON.parse(stored);
      this.clientsBrands = parsed.clients;

      if (
        this.clientsBrands.length === 1 &&
        this.clientsBrands[0].clientCode === "CLT00001"
      ) {
        this.showBigOrders = true;
      }

      this.filteredClients = this.clientsBrands
        .map((cb) => ({
          clientCode: cb.clientCode,
          clientName: cb.clientName,
        }))
        .sort((a, b) => {
          if (!a.clientName && !b.clientName) return 0;
          if (!a.clientName) return 1;
          if (!b.clientName) return -1;
          return a.clientName.localeCompare(b.clientName);
        });

      const allBrands: Brand[] = this.clientsBrands
        .flatMap((cb) =>
          cb.brands.map((b) => ({
            brandCode: b.brandCode,
            brandName: b.brandName,
          })),
        )
        .sort((a, b) => {
          if (!a.brandName && !b.brandName) return 0;
          if (!a.brandName) return 1;
          if (!b.brandName) return -1;
          return a.brandName.localeCompare(b.brandName);
        });

      this.filteredBrands = Array.from(
        new Map(allBrands.map((b) => [b.brandCode, b])).values(),
      );

      this.dropdownSettingsBrand = {
        singleSelection: false,
        idField: "brandCode",
        textField: "brandName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };
      this.dropdownSettingsClient = {
        singleSelection: false,
        idField: "clientCode",
        textField: "clientName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      this.dropdownSettingsDealer = {
        singleSelection: false,
        idField: "dealerCode",
        textField: "dealerName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      this.dropdownSettingsCarrier = {
        singleSelection: false,
        idField: "carrierCode",
        textField: "carrierName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      this.dropdownSettingsWarehouseFrom = {
        singleSelection: false,
        idField: "warehouseCode",
        textField: "warehouseName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      this.dropdownSettingsWarehouse = {
        singleSelection: false,
        idField: "warehouseCode",
        textField: "warehouseName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      this.dropdownSettingsRegion = {
        singleSelection: false,
        idField: "regionCode",
        textField: "regionName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      this.dropdownSettingsTour = {
        singleSelection: false,
        idField: "tourRoutingCode",
        textField: "tourRoutingCode",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      this.dropdownSettingsStatus = {
        singleSelection: false,
        idField: "value",
        textField: "label",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      forkJoin({
        warehouses: this.http.get<Warehouse[]>(
          `${environment.apiUrl}/tracking/warehouses`,
        ),
        carriers: this.http.get<Carrier[]>(
          `${environment.apiUrl}/tracking/carriers`,
        ),
        // Servono solo per le tendine: un errore non blocca la pagina
        dealers: this.http
          .post<Dealer[]>(
            `${environment.apiUrl}/tracking/dealers`,
            this.clientsBrands,
          )
          .pipe(catchError(() => of([] as Dealer[]))),
        regions: this.http
          .get<Region[]>(`${environment.apiUrl}/tracking/regions`)
          .pipe(catchError(() => of([] as Region[]))),
        tours: this.http
          .get<TourRouting[]>(
            `${environment.apiUrl}/overview-harmonizer/tour-routings`,
          )
          .pipe(catchError(() => of([] as TourRouting[]))),
      }).subscribe({
        next: (results) => {
          console.log("tours ", results.tours);
          this.filteredWarehouses = results.warehouses;
          this.filteredWarehousesFrom = results.warehouses.filter((w) =>
            w.warehouseType?.split(";").includes("CDR"),
          );
          this.filteredCarriers = results.carriers;
          this.filteredDealers = results.dealers;
          this.filteredTours = results.tours;
          this.filteredRegions = results.regions;
          // this.selectAllBrands();
          // this.selectAllClients();
          this.applyFilters();

          //this.loadData();
        },
        error: (err) => {
          console.error("Errore nel caricamento iniziale:", err);
        },
      });
    }

    this.startCutoffCountdownTimer();
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  private startCutoffCountdownTimer(): void {
    this.updateCutoffCountdowns();

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    this.countdownInterval = setInterval(() => {
      this.updateCutoffCountdowns();
    }, 1000);
  }

  private updateCutoffCountdowns(): void {
    const now = new Date().getTime();

    this.parcels = this.parcels.map((parcel) => {
      const cutoff = parcel.parcelDeliveryChangeCutoffDate
        ? new Date(parcel.parcelDeliveryChangeCutoffDate).getTime()
        : null;

      if (!cutoff || isNaN(cutoff)) {
        return {
          ...parcel,
          parcelDeliveryChangeCutoffCountdown: "",
          parcelDeliveryChangeCutoffExpired: false,
          parcelDeliveryChangeCutoffWarning: false,
        };
      }

      const diffMs = cutoff - now;

      if (diffMs <= 0) {
        return {
          ...parcel,
          parcelDeliveryChangeCutoffCountdown: "00:00:00",
          parcelDeliveryChangeCutoffExpired: true,
          parcelDeliveryChangeCutoffWarning: true,
        };
      }

      return {
        ...parcel,
        parcelDeliveryChangeCutoffCountdown: this.formatCountdown(diffMs),
        parcelDeliveryChangeCutoffExpired: false,
        parcelDeliveryChangeCutoffWarning: diffMs <= 5 * 60 * 1000,
      };
    });

    this.filteredParcels.forEach((parcel) => {
      const updated = this.parcels.find(
        (p) => p.parcelCode === parcel.parcelCode,
      );
      if (updated) {
        parcel.parcelDeliveryChangeCutoffCountdown =
          updated.parcelDeliveryChangeCutoffCountdown;
        parcel.parcelDeliveryChangeCutoffExpired =
          updated.parcelDeliveryChangeCutoffExpired;
        parcel.parcelDeliveryChangeCutoffWarning =
          updated.parcelDeliveryChangeCutoffWarning;
      }
    });
  }

  shouldHideBigOrdersToggle(): boolean {
    return (
      !!this.clientsBrands &&
      this.clientsBrands.length === 1 &&
      this.clientsBrands[0]?.clientCode === "CLT00001"
    );
  }

  private isColumnAllowed(col: any): boolean {
    if (col.specialOnly && !this.canSpecial()) {
      return false;
    } else if (col.updatableOnly && (!this.canSpecial() || !this.canUpdate())) {
      return false;
    }
    return true;
  }

  onClientsChange(): void {
    this.getIntersectionClientsBrands();
  }

  getIntersectionClientsBrands(): void {
    if (!this.selectedClients || this.selectedClients.length === 0) {
      // Nessun client selezionato → mostro tutti i brands
      this.filteredBrands = Array.from(
        new Map(
          this.clientsBrands
            .flatMap((cb) => cb.brands)
            .map((b) => [b.brandCode, b]),
        ).values(),
      );
      this.selectedBrands = []; // reset
      return;
    }

    // prendo i codici dei client selezionati
    const selectedCodes = this.selectedClients.map((c) => c.clientCode);

    // ottengo i brands per ogni client selezionato
    const brandLists = selectedCodes.map((code) => {
      const client = this.clientsBrands.find((cb) => cb.clientCode === code);
      return client ? client.brands : [];
    });

    // calcolo l’intersezione tra tutte le liste
    const intersection = brandLists.reduce((acc, curr) => {
      return acc.filter((b) => curr.some((x) => x.brandCode === b.brandCode));
    });

    // aggiorno i brands disponibili
    this.filteredBrands = intersection;
    this.selectedBrands = []; // reset per evitare selezioni incoerenti
  }

  selectAllClients() {
    this.selectedClients = [...this.filteredClients];

    this.getIntersectionClientsBrands();
  }

  deselectAllClients() {
    this.selectedClients = [];

    this.getIntersectionClientsBrands();
  }

  selectAllBrands() {
    this.selectedBrands = [...this.filteredBrands];
  }

  deselectAllBrands() {
    this.selectedBrands = [];
  }

  selectAllCarriers() {
    this.selectedCarriers = [...this.filteredCarriers];
  }

  deselectAllCarriers() {
    this.selectedCarriers = [];
  }

  selectAllDealers() {
    this.selectedDealers = [...this.filteredDealers];
  }

  deselectAllDealers() {
    this.selectedDealers = [];
  }

  selectAllRegions() {
    this.selectedRegions = [...this.filteredRegions];
  }

  deselectAllRegions() {
    this.selectedRegions = [];
  }

  selectAllTours() {
    this.selectedTours = [...this.filteredTours];
  }

  deselectAllTours() {
    this.selectedTours = [];
  }

  selectAllWarehousesFrom() {
    this.selectedWarehousesFrom = [...this.filteredWarehousesFrom];
  }

  deselectAllWarehousesFrom() {
    this.selectedWarehousesFrom = [];
  }

  selectAllWarehouses() {
    this.selectedWarehouses = [...this.filteredWarehouses];
  }

  deselectAllWarehouses() {
    this.selectedWarehouses = [];
  }

  selectAllStatuses() {
    this.selectedParcelDetailStatuses = [...this.parcelDetailStatusOptions];
  }

  deselectAllStatuses() {
    this.selectedParcelDetailStatuses = [];
  }

  loadWarehouses(): void {
    this.http
      .get<Warehouse[]>(`${environment.apiUrl}/tracking/warehouses`)
      .subscribe({
        next: (data) => {
          this.filteredWarehouses = data;
          this.filteredWarehousesFrom = data.filter(
            (w) => w.warehouseType === "CDR",
          );
        },
        error: () => console.error("Errore nel caricamento dei warehouse"),
      });
  }

  loadBrands(): void {
    this.http
      .get<Brand[]>(`${environment.apiUrl}/shipment-request/brands`)
      .subscribe({
        next: (data) => (this.filteredBrands = data),
        error: () => console.error("Errore nel caricamento dei brands"),
      });
  }

  onItemsPerPageChange(): void {
    this.currentPage = 1; // Reset alla prima pagina quando cambi il numero di elementi
    localStorage.setItem("itemsPerPage", this.itemsPerPage.toString());
  }

  resetItemsPerPage(): void {
    this.itemsPerPage = 25;
    this.currentPage = 1;
    localStorage.setItem("itemsPerPage", "25");
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    localStorage.setItem("currentParcelPage", page.toString());
    this.loadData(page);
  }

  readonly minimumFiltersMessage =
    "Inserisci almeno un Codice Collo, un Codice Bolla o un intervallo di date (Affido o Consegna Stimata).";

  // Filtri minimi per ricerca ed export: un codice collo, un codice bolla o un intervallo di date completo
  hasMinimumFilters(): boolean {
    const hasAnyCode =
      !!this.searchParcelCode || !!this.searchParcelWaybillCode;
    const hasValidDateRange =
      (!!this.parcelDateStart && !!this.parcelDateEnd) ||
      (!!this.parcelEstimatedDeliveryDateStart &&
        !!this.parcelEstimatedDeliveryDateEnd);
    return hasAnyCode || hasValidDateRange;
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.hasSearched = false;
    this.totalRecords = 0;

    this.dateError = "";

    const hasStartDate = !!this.parcelDateStart;
    const hasEndDate = !!this.parcelDateEnd;

    const hasEstimatedStartDate = !!this.parcelEstimatedDeliveryDateStart;
    const hasEstimatedEndDate = !!this.parcelEstimatedDeliveryDateEnd;

    // Verifica che ci sia almeno un criterio valido
    if (!this.hasMinimumFilters()) {
      this.dateError = this.minimumFiltersMessage;
      this.parcels = [];
      return;
    }

    // Controllo correttezza intervallo date Affido
    if ((hasStartDate && !hasEndDate) || (!hasStartDate && hasEndDate)) {
      this.dateError =
        "Per filtrare per data di affido devi inserire entrambe le date o rimuoverle entrambe.";
      this.parcels = [];
      return;
    }

    if (hasStartDate && hasEndDate) {
      const start = new Date(this.parcelDateStart);
      const end = new Date(this.parcelDateEnd);

      if (start > end) {
        this.dateError =
          "La data di inizio affido non può essere successiva alla data di fine.";
        this.parcels = [];
        return;
      }
    }

    // Controllo correttezza intervallo date Consegna Stimata
    if (
      (hasEstimatedStartDate && !hasEstimatedEndDate) ||
      (!hasEstimatedStartDate && hasEstimatedEndDate)
    ) {
      this.dateError =
        "Per filtrare per data di consegna stimata devi inserire entrambe le date o rimuoverle entrambe.";
      this.parcels = [];
      return;
    }

    if (hasEstimatedStartDate && hasEstimatedEndDate) {
      const start = new Date(this.parcelEstimatedDeliveryDateStart);
      const end = new Date(this.parcelEstimatedDeliveryDateEnd);

      if (start > end) {
        this.dateError =
          "La data di inizio consegna stimata non può essere successiva alla data di fine.";
        this.parcels = [];
        return;
      }
    }

    this.loadWarehouses();
    this.loadData();
  }

  // Filtri di ricerca correnti (senza paginazione né ordinamento), comuni a ricerca ed export
  private buildSearchFilters() {
    let clientsBrandsSelected: ClientsBrands[];

    if (this.filteredClients.length == 1) {
      this.selectedClients = [...this.filteredClients];
    }

    if (this.selectedClients.length > 0) {
      clientsBrandsSelected = this.selectedClients.map((sc) => {
        const originalClient = this.clientsBrands.find(
          (cb) => cb.clientCode === sc.clientCode,
        );

        let filteredBrandsFromClient: Brand[] = [];

        if (this.selectedBrands.length > 0) {
          filteredBrandsFromClient = (originalClient?.brands || []).filter(
            (b) =>
              this.selectedBrands.some((sb) => sb.brandCode === b.brandCode),
          );
        } else {
          filteredBrandsFromClient = this.filteredBrands;
        }

        return {
          clientCode: sc.clientCode,
          clientName: sc.clientName,
          brands: filteredBrandsFromClient,
        } as ClientsBrands;
      });
    } else if (this.selectedBrands && this.selectedBrands.length > 0) {
      clientsBrandsSelected = this.clientsBrands
        .map((cb) => {
          const matchingBrands = cb.brands.filter((b) =>
            this.selectedBrands.some((sb) => sb.brandCode === b.brandCode),
          );

          if (matchingBrands.length > 0) {
            return {
              clientCode: cb.clientCode,
              clientName: cb.clientName,
              brands: matchingBrands,
            } as ClientsBrands;
          }

          return null;
        })
        .filter((cb) => cb !== null) as ClientsBrands[];
    } else {
      clientsBrandsSelected = this.clientsBrands;
    }

    return {
      clients: clientsBrandsSelected || [],

      parcelWaybillCode: this.searchParcelWaybillCode || "",
      parcelCode: this.searchParcelCode || "",
      parcelDateStart: this.parcelDateStart,
      parcelDateEnd: this.parcelDateEnd,
      parcelDealerCodes: this.searchDealerCode
        ? [this.searchDealerCode]
        : this.selectedDealers.map((d) => d.dealerCode),
      carrierCodes: this.selectedCarriers.map((c) => c.carrierCode),

      warehouseCodes: this.selectedWarehouses.map((w) => w.warehouseCode),
      warehouseFromCodes: this.selectedWarehousesFrom.map(
        (w) => w.warehouseCode,
      ),

      regionCodes: this.selectedRegions.map((r) => r.regionCode),
      deliveryTypes: this.selectedTours.map((t) => t.tourRoutingCode),

      nightDay: this.scheduleIsNight,

      parcelEstimatedDeliveryDateStart: this.parcelEstimatedDeliveryDateStart,
      parcelEstimatedDeliveryDateEnd: this.parcelEstimatedDeliveryDateEnd,

      waybillDDT: this.searchDDTCodes,

      // prima erano filtri in front
      inRangeStatus: this.inRangeStatus,
      notificationStatus: this.notificationStatus,
      deliveryStatus: this.deliveryStatus,
      modifyStatus: this.modifyStatus,
      onTimeStatus: this.onTimeStatus,
      scheduleType: this.scheduleType,
      deliveryMethod: this.selectedDeliveryMethod,
      withProblemsStatus: this.withProblemsStatus,
      detailStatuses:
        this.selectedParcelDetailStatuses?.map((s) => s.value) || [],
    };
  }

  loadData(page: number = 1): void {
    this.isLoading = true;
    this.isLoadingParcels = true;

    // PAGINAZIONE
    this.currentPage = page;

    const body = {
      ...this.buildSearchFilters(),

      page: this.currentPage,
      pageSize: this.itemsPerPage,

      sortBy: this.sortState.active,
      sortDirection: this.sortState.direction,
    };

    this.http
      .post<any>(`${environment.apiUrl}/overview-harmonizer/parcels`, body)
      .subscribe({
        next: (response) => {
          this.totalRecords = response.totalCount;
          this.currentPage = response.page;
          this.itemsPerPage = response.pageSize;

          this.parcels = response.parcels.map((p: ViewParcels) => {
            console.log("parcels ", this.parcels);
            const isBigOrder = p.parcelWaybillDeliveryMethod === "BIG_ORDER";

            return {
              ...p,
              isBigOrder,
              showTrackings: false,
              showComParcels: false,
              activeTab: "tracking" as "tracking" | "map",
              minutesDelay: this.getMinutesDelayNumber(
                p.parcelOnTime,
                p.parcelDeliveryDate,
                p.parcelEstimatedDeliveryDate,
              ),
            };
          });

          this.updateCutoffCountdowns();

          this.filteredParcels = this.parcels;
          this.hasSearched = true;
          this.isLoading = false;
          this.isLoadingParcels = false;
        },

        error: (err) => {
          console.error("Errore durante la chiamata HTTP:", err);
          this.isLoading = false;
          this.isLoadingParcels = false;
        },
      });
  }

  toDateOnlyLocal(d: string | Date | null | undefined): string | null {
    if (!d) return null;

    const date = new Date(d);
    if (isNaN(date.getTime())) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  openEditModal(parcel: ViewParcels) {
    this.selectedParcel = parcel;
    this.editChoice = null;
    this.successDeliveryPropagation = false;
    this.errorDeliveryPropagation = null;
    this.errorDeliveryNull = false;
    this.numberParcelsOfWaybill = this.parcels.filter(
      (p) => p.parcelWaybillCode === parcel.parcelWaybillCode,
    ).length;
    this.editForm = {
      parcelDate: this.formatDateForInput(parcel.parcelDate),
      parcelDeliveryDate: this.formatDateForInput(parcel.parcelDeliveryDate),
      parcelDescription: parcel.parcelDescription,
      parcelWeight: parcel.parcelWeight,
      parcelVolume: parcel.parcelVolume,
      parcelLatitude: parcel.parcelLatitude,
      parcelLongitude: parcel.parcelLongitude,
    };

    this.originalEdit = {
      parcelDeliveryDate: this.editForm.parcelDeliveryDate ?? null,
      parcelLatitude: this.editForm.parcelLatitude ?? null,
      parcelLongitude: this.editForm.parcelLongitude ?? null,
    };

    if (parcel.clientRequestSignature == "Y") {
      let params = new HttpParams()
        .set("waybillCode", parcel.parcelWaybillCode)
        .set("waybillShipmentCode", parcel.waybillShipmentCode);
      this.http
        .get(`${environment.apiUrl}/tracking/signature/`, {
          params,
          responseType: "text",
        })
        .subscribe({
          next: (signature) => {
            this.parcelSignature = signature;

            this.signaturePreview = this.parcelSignature
              ? this.getSignatureImageSrc(this.parcelSignature)
              : null;

            this.signatureError = null;
            this.signatureInitialized = false;

            this.isReplacingSignature = !this.parcelSignature;

            if (this.isReplacingSignature) {
              this.updateSignatureCanvasAfterModalOpen();
            }
          },
          error: (err) => {
            console.error(
              "Errore durante la chiamata HTTP requestSignature:",
              err,
            );
            this.isLoading = false;
          },
        });
    }

    if (parcel.parcelLatitude == null && parcel.parcelLongitude == null) {
      this.isCoordinatesCorrectSelectedParcel = true;
      this.showButtonCreateCoordinates = false;
    } else {
      let params = new HttpParams()
        .set("latitude", parcel.parcelLatitude)
        .set("longitude", parcel.parcelLongitude)
        .set("dealerCode", parcel.parcelDealerCode);
      this.http
        .get<boolean>(`${environment.apiUrl}/tracking/coordinates/inrange/`, {
          params,
        })
        .subscribe({
          next: (coordinatesCorrect) => {
            this.showButtonCreateCoordinates = coordinatesCorrect;
            this.isCoordinatesCorrectSelectedParcel = coordinatesCorrect;
          },
          error: (err) => {
            console.error("Errore durante la chiamata HTTP:", err);
            this.isLoading = false; // nascondi il loader anche in caso di errore
          },
        });
    }

    if (this.selectedParcel?.isRestrictedClient == "Y") {
      this.setRestrictedNowDeliveryDate();
    } else {
      const now = new Date();
      if (this.editForm.parcelDeliveryDate == null) {
        this.editForm.parcelDeliveryDate = this.formatDateForInput(now);
      }
      this.restrictedMinutes = null;
    }

    this.showModal = true;
  }

  formatDateForInput(date: string | Date | null): string | null {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    const hours = ("0" + d.getHours()).slice(-2);
    const minutes = ("0" + d.getMinutes()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  closeModal(): void {
    this.showModal = false;
    this.successDeliveryPropagation = false;
    this.errorDeliveryPropagation = null;
    this.errorDeliveryNull = false;
    this.isLoading = false;
    this.selectedParcel = null;
    this.editChoice = null;
    this.signaturePreview = null;
    this.signatureError = null;
    this.signatureInitialized = false;
    this.isReplacingSignature = false;
  }

  startEditSave(scope: "parcel" | "waybill") {
    this.editChoice = scope;
  }

  cancelEditConfirm() {
    this.editChoice = null;
  }

  confirmEditSave() {
    if (!this.selectedParcel || !this.editChoice) return;

    if (!this.editForm.parcelDeliveryDate) {
      this.errorDeliveryNull = true;
      return;
    }

    if (this.editChoice === "parcel") {
      this.saveChanges(false);
      return;
    }

    this.saveChanges(true);
  }

  saveChanges(allParcels: boolean = false) {
    if (!this.selectedParcel) return;

    if (!this.editForm.parcelDeliveryDate) {
      this.errorDeliveryNull = true;
      return;
    }

    let signatureBase64: string | null = null;

    if (this.selectedParcel.clientRequestSignature == "Y") {
      // Caso 1: sto mostrando la firma già salvata e non la sto sostituendo
      if (this.showSavedSignatureOnly()) {
        signatureBase64 = this.parcelSignature ?? null;
      }
      // Caso 2: sto disegnando una nuova firma
      else {
        if (!this.signaturePad || this.signaturePad.isEmpty()) {
          this.signatureError = "Inserisci una firma prima di salvare.";
          return;
        }

        const signatureDataUrl = this.buildSignatureImage();
        if (!signatureDataUrl) {
          this.signatureError = "Errore durante la generazione della firma.";
          return;
        }

        signatureBase64 = this.extractPureBase64(signatureDataUrl);
      }
    }

    const updated = {
      parcelCode: this.selectedParcel.parcelCode,
      ...this.editForm,
      parcelDate: this.editForm.parcelDate
        ? new Date(this.editForm.parcelDate)
            .toISOString()
            .replace("Z", "+00:00")
        : null,
      parcelDeliveryDate: this.editForm.parcelDeliveryDate
        ? new Date(this.editForm.parcelDeliveryDate)
            .toISOString()
            .replace("Z", "+00:00")
        : null,
      parcelLatitude: this.editForm.parcelLatitude,
      parcelLongitude: this.editForm.parcelLongitude,
      parcelClientCode: this.selectedParcel.parcelClientCode,
      parcelBrandCode: this.selectedParcel.parcelBrandCode,
      parcelSignature: signatureBase64,
    };

    this.http
      .put(
        `${environment.apiUrl}/tracking/parcels/${this.selectedParcel.parcelCode}/${allParcels}`,
        updated,
      )
      .subscribe({
        next: () => {
          this.closeModal();
          this.loadData(); // ricarica i dati aggiornati dal server
        },
        error: (err) => {
          if (err.status === 304) {
            // mostra la notifica centrale con il messaggio del body
            this.notificationMessage = err.error; // "Collo già notificato, impossibile salvare le modifiche"
            this.showNotification = true;
          } else {
            console.dir(updated);
            this.closeModal();
            const message = this.errorHelperService.extractBackendMessage(err);
            this.notificationService.error(`Errore: ${message}`);
          }
        },
      });
  }

  calculateRandomCoordinates(parcel: ViewParcels | null) {
    if (parcel != null) {
      let params = new HttpParams().set("dealerCode", parcel.parcelDealerCode);
      this.http
        .get(`${environment.apiUrl}/tracking/coordinates/random/`, {
          params,
          responseType: "text" as const,
        })
        .subscribe({
          next: (coordinates: string) => {
            const [latitudeStr, longitudeStr] = coordinates.split(";");
            const parcelLongitude = parseFloat(longitudeStr);
            const parcelLatitude = parseFloat(latitudeStr);

            this.editForm.parcelLatitude =
              Math.trunc(parcelLatitude * 1e7) / 1e7;
            this.editForm.parcelLongitude =
              Math.trunc(parcelLongitude * 1e7) / 1e7;
            this.coordinatesValid = true;
            this.isCoordinatesCorrectSelectedParcel = true;
          },
          error: (err) => {
            console.error("Errore durante la chiamata HTTP:", err);
            this.isLoading = false;
          },
        });
    }
  }

  propagaDataConsegna(): void {
    if (!this.editForm.parcelDeliveryDate || !this.selectedParcel?.parcelCode) {
      this.errorDeliveryPropagation =
        "Data di consegna o codice collo non disponibile.";
      this.successDeliveryPropagation = false;
      return;
    }

    const body = {
      parcelDeliveryDate: new Date(this.editForm.parcelDeliveryDate)
        .toISOString()
        .replace("Z", "+00:00"),
      parcelClientCode: this.selectedParcel.parcelClientCode,
      parcelBrandCode: this.selectedParcel.parcelBrandCode,
    };

    this.isLoading = true;

    this.http
      .put(
        `${environment.apiUrl}/tracking/parcelsPropagateDeliveryDate/${this.selectedParcel.parcelWaybillCode}`,
        body,
        {
          headers: { "Content-Type": "application/json" },
        },
      )
      .subscribe({
        next: () => {
          this.successDeliveryPropagation = true;
          this.errorDeliveryPropagation = null;
          this.isLoading = false;
        },
        error: (err) => {
          this.errorDeliveryPropagation = err?.error || "Errore generico";
          this.successDeliveryPropagation = false;
          this.isLoading = false;
        },
      });
  }

  exportParcelsToExcel(): void {
    this.exportParcels(false, "totale_colli");
  }

  exportParcelsOriginalToExcel(): void {
    this.exportParcels(true, "totale_colli_con_dati_originali");
  }

  // Export lato server di tutti i colli che corrispondono ai filtri, non solo della pagina visualizzata
  private exportParcels(
    withOriginalData: boolean,
    fallbackBaseName: string,
  ): void {
    if (!this.hasMinimumFilters()) {
      return;
    }

    this.exportingType = withOriginalData ? "original" : "standard";

    const filters = {
      ...this.buildSearchFilters(),
      sortBy: this.sortState.active,
      sortDirection: this.sortState.direction,
    };

    this.overviewHarmonizerService
      .exportParcelsExcel(filters, withOriginalData)
      .subscribe({
        next: ({ blob, fileName }) => {
          this.exportingType = null;

          const now = new Date();
          const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}${now.getHours().toString().padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now.getSeconds().toString().padStart(2, "0")}`;

          FileSaver.saveAs(
            blob,
            fileName ?? `${fallbackBaseName}_${timestamp}.xlsx`,
          );
        },
        error: (err) => {
          this.exportingType = null;
          console.error("Errore durante l'esportazione Excel:", err);
          this.notificationService.error(
            this.errorHelperService.extractBackendMessage(err),
          );
        },
      });
  }

  resetFilters(): void {
    this.scheduleType = "";
    this.selectedClients = [];
    this.selectedBrands = [];
    this.searchDealerCode = "";
    this.searchDDTCodes = "";
    this.selectedDealerCode = "";
    this.notificationStatus = "";
    this.justificationStatus = "";
    this.deliveryStatus = "";
    this.searchParcelCode = "";
    this.searchParcelWaybillCode = "";
    this.inRangeStatus = "";
    this.selectedCarrierCode = "";
    this.warehouseCode = "";
    this.warehouseFromCode = "";
    this.selectedRegionCode = "";
    this.onTimeStatus = "";
    this.modifyStatus = "";
    this.withProblemsStatus = "";
    this.selectedDeliveryType = "";
    this.scheduleIsNight = "";
    this.selectedDeliveryMethod = "";
    this.parcelDateStart = "";
    this.parcelDateEnd = "";
    this.parcelEstimatedDeliveryDateStart = "";
    this.parcelEstimatedDeliveryDateEnd = "";
    this.misroutingStatus = "";
    this.showUndefinedParcels = false;
    this.showBigOrders = false;

    this.selectedDealers = [];
    this.selectedCarriers = [];
    this.selectedWarehousesFrom = [];
    this.selectedWarehouses = [];
    this.selectedRegions = [];
    this.selectedTours = [];
    this.selectedParcelDetailStatuses = [];
    //this.calcolaDataDefaultFiltri();

    // Applica di nuovo il filtro (se necessario)
    this.applyFilters();
  }

  calcolaDataDefaultFiltri(): void {
    // Calcolo data predefinita (ieri o venerdì)
    const today = new Date();
    let defaultDate = new Date(today);

    if (today.getDay() === 0) {
      // Domenica → venerdì
      defaultDate.setDate(today.getDate() - 2);
    } else if (today.getDay() === 1) {
      // Lunedì → venerdì
      defaultDate.setDate(today.getDate() - 3);
    } else {
      // Altri giorni → ieri
      defaultDate.setDate(today.getDate() - 1);
    }

    const formattedDate = defaultDate.toISOString().split("T")[0];
    this.parcelDateStart = formattedDate;
    this.parcelDateEnd = formattedDate;
  }

  viewDetailsModifiesManual(parcel: ViewParcels) {
    this.selectedParcel = parcel;
    this.showModalDetailModifies = true;
  }

  closeModalDetailModifies() {
    this.selectedParcel = null;
    this.showModalDetailModifies = false;
  }

  private shiftDate(dateStr: string, days: number): string {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + days);
    return date.toISOString().substring(0, 10); // Format: yyyy-mm-dd
  }

  shiftCreationDates(days: number): void {
    if (this.parcelDateStart) {
      this.parcelDateStart = this.shiftDate(this.parcelDateStart, days);
    } else {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.parcelDateStart = this.shiftDate(formattedDate, days);
    }
    if (this.parcelDateEnd) {
      this.parcelDateEnd = this.shiftDate(this.parcelDateEnd, days);
    } else {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.parcelDateEnd = this.shiftDate(formattedDate, days);
    }
  }

  shiftEstimatedDates(days: number): void {
    if (this.parcelEstimatedDeliveryDateStart) {
      this.parcelEstimatedDeliveryDateStart = this.shiftDate(
        this.parcelEstimatedDeliveryDateStart,
        days,
      );
    } else {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.parcelEstimatedDeliveryDateStart = this.shiftDate(
        formattedDate,
        days,
      );
    }

    if (this.parcelEstimatedDeliveryDateEnd) {
      this.parcelEstimatedDeliveryDateEnd = this.shiftDate(
        this.parcelEstimatedDeliveryDateEnd,
        days,
      );
    } else {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.parcelEstimatedDeliveryDateEnd = this.shiftDate(formattedDate, days);
    }
  }

  applySortManual(): void {
    if (this.sortState.active && this.sortState.direction) {
      const isAsc = this.sortState.direction === "asc";
      this.filteredParcels = [...this.filteredParcels].sort((a, b) =>
        this.compare(
          (a as any)[this.sortState.active] || "",
          (b as any)[this.sortState.active] || "",
          isAsc,
        ),
      );
    } else {
      // Ripristina l'ordine originale
      //this.filteredParcels = [...this.parcels]; // o una copia della lista originale
    }
  }

  compare(a: string | number, b: string | number, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getMinutesDelayNumber(
    parcelOnTime: string,
    parcelDeliveryDate: string,
    parcelEstimatedDeliveryDate: string,
  ): number {
    if (
      parcelOnTime === "ON_TIME" ||
      !parcelDeliveryDate ||
      !parcelEstimatedDeliveryDate
    ) {
      return 0;
    }

    const deliveryDate = new Date(parcelDeliveryDate);
    const estimatedDate = new Date(parcelEstimatedDeliveryDate);

    const diffMs = deliveryDate.getTime() - estimatedDate.getTime();
    return Math.max(Math.floor(diffMs / (1000 * 60)), 0);
  }

  getValue(p: any, field: string): any {
    return p[field];
  }

  undoParcel(parcel: any, allParcels: boolean) {
    this.isLoading = true;
    this.showRollbackModal = true;

    this.http
      .put(
        `${environment.apiUrl}/tracking/rollbackDelivery/${parcel.parcelCode}/${allParcels}`,
        null,
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.loadData();
          this.closeRollbackModal();
          this.notificationService.success("Consegna annullata con successo!");
        },
        error: (err) => {
          this.isLoading = false;
          this.closeRollbackModal();
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        },
      });
  }

  closeRollbackModal() {
    this.showRollbackModal = false;
    this.selectedParcel = null;
    this.rollbackChoice = null;
  }

  openRollbackModal(parcel: any) {
    this.selectedParcel = parcel;
    this.showRollbackModal = true;
    this.rollbackChoice = null;
    this.numberParcelsOfWaybill = this.parcels.filter(
      (p) =>
        p.parcelWaybillCode == parcel.parcelWaybillCode &&
        p.parcelDeliveryStatus == "DELIVERED",
    ).length;
  }

  startRollback(scope: "parcel" | "waybill") {
    this.rollbackChoice = scope;
  }

  cancelRollback() {
    this.rollbackChoice = null;
  }

  confirmRollback() {
    if (!this.selectedParcel || !this.rollbackChoice) return;
    const allParcels = this.rollbackChoice === "waybill";
    this.undoParcel(this.selectedParcel, allParcels);
  }

  coordinateRegex = /^-?[1-9]\d?([,.]\d+)?$/;

  coordinatesValid = true;

  checkCoordinates() {
    const latStr = this.editForm.parcelLatitude
      ?.toString()
      .replace(",", ".")
      .trim();
    const lonStr = this.editForm.parcelLongitude
      ?.toString()
      .replace(",", ".")
      .trim();

    const latEmpty = !latStr;
    const lonEmpty = !lonStr;

    const latOk = latEmpty || this.coordinateRegex.test(latStr);
    const lonOk = lonEmpty || this.coordinateRegex.test(lonStr);

    this.coordinatesValid = latOk && lonOk;

    if (latOk && !latEmpty) {
      this.editForm.parcelLatitude = parseFloat(latStr);
    }
    if (lonOk && !lonEmpty) {
      this.editForm.parcelLongitude = parseFloat(lonStr);
    }
  }

  getJustificationLabel(type: string): string {
    switch (type) {
      case "MISSING_DELIVERY":
        return "MANCATA CONSEGNA";
      case "DELAY":
        return "RITARDO";
      default:
        return type;
    }
  }

  getLineClassStart(p: ViewParcels) {
    if (p.parcelDate) return "line-green";
    return "line-grey";
  }

  getWarehouseName(code: string) {
    return this.filteredWarehouses.filter((w) => w.warehouseCode == code)
      .length > 0
      ? this.filteredWarehouses.filter((w) => w.warehouseCode == code)[0]
          .warehouseName
      : code;
  }

  getWarehouseNameComParcel(code: string | undefined) {
    return this.filteredWarehouses.filter((w) => w.warehouseCode == code)
      .length > 0
      ? this.filteredWarehouses.filter((w) => w.warehouseCode == code)[0]
          .warehouseName
      : null;
  }

  getWarehouseShortNameComParcel(code: string | undefined) {
    return this.filteredWarehouses.filter((w) => w.warehouseCode == code)
      .length > 0
      ? this.filteredWarehouses.filter((w) => w.warehouseCode == code)[0]
          .warehouseShortName
      : null;
  }

  getDealerName(code: string | undefined) {
    return this.filteredDealers.filter((d) => d.dealerCode == code).length > 0
      ? this.filteredDealers.filter((d) => d.dealerCode == code)[0].dealerName
      : null;
  }

  getCarrierName(code: string | undefined) {
    return this.filteredCarriers.filter((d) => d.carrierCode == code).length > 0
      ? this.filteredCarriers.filter((d) => d.carrierCode == code)[0]
          .carrierName
      : code;
  }

  // per convertire stringhe data a Date in caso servisse nel template
  toDate(d?: string | Date | null): Date | null {
    if (!d) return null;
    return d instanceof Date ? d : new Date(d);
  }

  private matchesOnTimeFilter(parcel: ViewParcels): boolean {
    // Nessun filtro selezionato → sempre true
    if (!this.onTimeStatus) {
      return true;
    }

    const status = parcel.parcelOnTime;

    // Filtro base solo sullo stato ON_TIME / NOT_ON_TIME
    if (this.onTimeStatus === "ON_TIME") {
      return status === "ON_TIME";
    }

    if (this.onTimeStatus === "NOT_ON_TIME") {
      return status === "NOT_ON_TIME";
    }

    // Da qui in poi filtriamo sui bucket di ritardo, SOLO se NOT_ON_TIME
    if (status !== "NOT_ON_TIME") {
      return false;
    }

    // calcolo differenza SOLO se NOT_ON_TIME
    const delayMinutes = this.getMinutesDelayNumber(
      parcel.parcelOnTime,
      parcel.parcelDeliveryDate,
      parcel.parcelEstimatedDeliveryDate,
    );

    // se non riesco a calcolare o è zero, non rientra nei bucket
    if (!delayMinutes || delayMinutes <= 0) {
      return false;
    }

    switch (this.onTimeStatus) {
      case "DELAY_LT_2H":
        // ritardo > 0 e ≤ 2h
        return delayMinutes > 0 && delayMinutes <= 120;

      case "DELAY_2H_3H":
        // 2h < ritardo ≤ 3h
        return delayMinutes > 120 && delayMinutes <= 180;

      case "DELAY_3H_1D":
        // 3h < ritardo ≤ 1 giorno (1440 min)
        return delayMinutes > 180 && delayMinutes <= 1440;

      case "DELAY_GT_1D":
        // ritardo > 1 giorno
        return delayMinutes > 1440;

      default:
        return true;
    }
  }

  getParcelDetailStatusLabel(status: string | null | undefined): string {
    if (!status) return "";

    switch (status) {
      case "PREPARED":
        return ParcelDetailStatus.PREPARED;
      case "CLOSED":
        return ParcelDetailStatus.CLOSED;
      case "IN_TRIP_TO_TP":
        return ParcelDetailStatus.IN_TRIP_TO_TP;
      case "IN_TRIP":
        return ParcelDetailStatus.IN_TRIP;
      case "SUSPENDED":
        return ParcelDetailStatus.SUSPENDED;
      default:
        // se ti arriva già "Preparata" o qualcosa di imprevisto
        return status;
    }
  }

  onRestrictedMinutesChange(min: number): void {
    if (this.selectedParcel?.isRestrictedClient == "N") return;
    if (!this.editForm.parcelDeliveryDate) return;

    const clamped = Math.min(59, Math.max(0, Number(min)));
    this.restrictedMinutes = clamped;

    // Mantieni fissi YYYY-MM-DDTHH e cambia solo i minuti
    // parcelDeliveryDate è una stringa "YYYY-MM-DDTHH:mm"
    const base = this.editForm.parcelDeliveryDate.slice(0, 14); // "YYYY-MM-DDTHH:"
    this.editForm.parcelDeliveryDate = `${base}${this.pad2(clamped)}`;
  }

  private setRestrictedNowDeliveryDate(): void {
    const now = new Date();
    if (this.editForm.parcelDeliveryDate == null) {
      this.editForm.parcelDeliveryDate = this.formatDateForInput(now);

      this.restrictedMinutes = now.getMinutes();
    }
  }

  private pad2(n: number): string {
    return String(n).padStart(2, "0");
  }

  private initSignaturePad(): void {
    if (!this.signatureCanvas?.nativeElement) return;

    const canvas = this.signatureCanvas.nativeElement;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;

    const ctx = canvas.getContext("2d");
    if (ctx) {
      ctx.scale(ratio, ratio);
    }

    this.signaturePad = new SignaturePad(canvas, {
      minWidth: 0.8,
      maxWidth: 2.0,
      throttle: 16,
    });

    this.signaturePad.addEventListener("endStroke", () => {
      this.refreshSignaturePreview();
    });

    this.signatureInitialized = true;

    if (this.parcelSignature) {
      this.fromDataUrlToPad(this.parcelSignature);
    }
  }

  private updateSignatureCanvasAfterModalOpen(): void {
    setTimeout(() => {
      this.initSignaturePad();
    }, 0);
  }

  clearSignature(): void {
    if (!this.signaturePad) return;
    this.signaturePad.clear();
    this.signaturePreview = null;
    this.signatureError = null;
  }

  private fromDataUrlToPad(dataUrl: string): void {
    if (!this.signaturePad) return;

    const image = new Image();
    image.onload = () => {
      const canvas = this.signatureCanvas?.nativeElement;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      this.signaturePad.clear();
      ctx.drawImage(
        image,
        0,
        0,
        canvas.width / (window.devicePixelRatio || 1),
        canvas.height / (window.devicePixelRatio || 1),
      );
      this.signaturePreview = dataUrl;
    };
    image.src = dataUrl;
  }

  loadSavedSignature(): void {
    if (!this.parcelSignature) {
      return;
    }

    this.isReplacingSignature = false;
    this.signatureError = null;
    this.signaturePreview = this.getSignatureImageSrc(this.parcelSignature);

    if (this.signaturePad) {
      this.signaturePad.clear();
    }
  }

  refreshSignaturePreview(): void {
    this.signaturePreview = this.buildSignatureImage();
  }

  private buildSignatureImage(): string | null {
    if (!this.signaturePad || this.signaturePad.isEmpty()) {
      return null;
    }

    const sourceCanvas = this.signatureCanvas?.nativeElement;
    if (!sourceCanvas) return null;

    const exportCanvas = document.createElement("canvas");
    exportCanvas.width = 580;
    exportCanvas.height = 155;

    const ctx = exportCanvas.getContext("2d");
    if (!ctx) return null;

    ctx.fillStyle = "#bebebe";
    ctx.font = "bold 14px Segoe UI, Helvetica, Arial, sans-serif";
    ctx.textBaseline = "top";

    ctx.scale(0.87, 1);
    ctx.fillText(this.selectedParcel?.parcelWaybillCode ?? "", 22, 23);

    ctx.drawImage(sourceCanvas, 0, 0, exportCanvas.width, exportCanvas.height);

    return exportCanvas.toDataURL("image/png");
  }

  showSavedSignatureOnly(): boolean {
    return !!this.parcelSignature && !this.isReplacingSignature;
  }

  getSignatureImageSrc(base64?: string | null): string {
    if (!base64) {
      return "";
    }

    if (base64.startsWith("data:image")) {
      return base64;
    }

    return `data:image/png;base64,${base64}`;
  }

  enableSignatureEditing(): void {
    this.isReplacingSignature = true;
    this.signaturePreview = null;
    this.signatureError = null;

    setTimeout(() => {
      this.initSignaturePad();
    }, 0);
  }

  private extractPureBase64(dataUrl: string): string {
    if (!dataUrl) {
      return "";
    }

    const parts = dataUrl.split(",");
    return parts.length > 1 ? parts[1] : dataUrl;
  }

  get isSignatureChanged(): boolean {
    if (this.showSavedSignatureOnly()) {
      return false;
    }

    return !!this.signaturePad && !this.signaturePad.isEmpty();
  }

  private formatCountdown(diffMs: number): string {
    const totalSeconds = Math.floor(diffMs / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${this.pad2(hours)}:${this.pad2(minutes)}:${this.pad2(seconds)}`;
  }

  openImportExcelModal() {
    this.showImportExcelModal = true;
  }

  closeImportExcelModal() {
    this.showImportExcelModal = false;
    this.selectedExcelFile = null!;
  }

  onFileSelected(event: any) {
    if (event.target.files.length > 0) {
      this.selectedExcelFile = event.target.files[0];
    }
  }

  downloadTemplateExcel() {
    this.http
      .get(`${environment.apiUrl}/overview-harmonizer/template-deliveries`, {
        responseType: "blob",
      })
      .subscribe((res) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "template_consegne.xlsx";
        a.click();

        window.URL.revokeObjectURL(url);
      });
  }

  importExcelDeliveries() {
    this.isLoading = true;
    const formData = new FormData();
    formData.append("file", this.selectedExcelFile);

    this.http
      .post(
        `${environment.apiUrl}/overview-harmonizer/import-excel-deliveries`,
        formData,
      )
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.loadData();
          this.closeImportExcelModal();
          this.notificationService.success("Excel importato con successo");
        },
        error: (err) => {
          this.isLoading = false;
          this.closeImportExcelModal();
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        },
      });
  }

  setSort(field: string): void {
    if (this.sortState.active === field) {
      if (this.sortState.direction === "asc") {
        this.sortState.direction = "desc";
      } else if (this.sortState.direction === "desc") {
        this.sortState.active = "";
        this.sortState.direction = "";
      } else {
        this.sortState.direction = "asc";
      }
    } else {
      this.sortState.active = field;
      this.sortState.direction = "asc";
    }

    this.loadData();
  }
}
